var moduleMap = {
	"./UnityDashboard": () => {
		return Promise.all(/* __federation_expose_UnityDashboard */[__webpack_require__.e(786), __webpack_require__.e(271), __webpack_require__.e(445), __webpack_require__.e(382), __webpack_require__.e(272), __webpack_require__.e(629), __webpack_require__.e(723), __webpack_require__.e(764), __webpack_require__.e(405), __webpack_require__.e(22), __webpack_require__.e(770), __webpack_require__.e(328), __webpack_require__.e(256), __webpack_require__.e(76), __webpack_require__.e(217), __webpack_require__.e(156), __webpack_require__.e(537), __webpack_require__.e(219), __webpack_require__.e(16)]).then(() => (() => ((__webpack_require__(6857)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope, remoteEntryInitOptions) => {
	return __webpack_require__.federation.bundlerRuntime.initContainerEntry({	webpackRequire: __webpack_require__,
		shareScope: shareScope,
		initScope: initScope,
		remoteEntryInitOptions: remoteEntryInitOptions,
		shareScopeKey: "default"
	})
};
// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});